import { SystemFormData } from "./types";

export const calculateCriticalityScore = (
  scores: SystemFormData["criticalityScores"]
) => {
  const weights = {
    impactOnSupply: 0.3,
    healthRisk: 0.25,
    redundancy: 0.15,
    dependency: 0.15,
    customerImpact: 0.15,
  };

  const totalScore =
    scores.impactOnSupply * weights.impactOnSupply +
    scores.healthRisk * weights.healthRisk +
    scores.redundancy * weights.redundancy +
    scores.dependency * weights.dependency +
    scores.customerImpact * weights.customerImpact;

  return Math.round(totalScore * 100) / 100;
};

export const getCriticalityLevel = (score: number): string => {
  if (score >= 4) return "High";
  if (score >= 3) return "Medium";
  if (score >= 2) return "Medium";
  if (score >= 1) return "Low";
  return "Low";
};
